import React from "react";
import FormulaRenderer from "../../../../../../../math-formula";

function LongText({ data }: any) {
return (
    <div className="choose-correct">
      {data?.questions &&
        data?.questions?.length > 0 &&
        data?.questions?.map((quiz: any) => (
          <div
            key={quiz?.id}
            className={`font-size-16 line-height-24 font-weight-5 text-result`}
          >
            <FormulaRenderer
              className="ml-1"
              htmlString={quiz?.content || "N/A"}
            />
          </div>
        ))}
    </div>
  );
}

export default LongText;
